import { createRootRoute, Outlet } from "@tanstack/react-router"

import { InvestorShell } from "@/components/InvestorShell"

export const Route = createRootRoute({
  component: InvestorRootLayout,
})

function InvestorRootLayout() {
  return (
    <InvestorShell>
      <Outlet />
    </InvestorShell>
  )
}
